<template>
  <footer
    class="mainfooter"
    role="contentinfo"
    id="footer"
  >
    <div class="wp_mainFooterContainer">
      <div class="container wp_FooterContainer">
        <div class="row pt-3 pb-3 m-0">
          <div class="col-12 col-md-6 col-xl-3">
            <h5 data-test="footerHead1" id="footerHead1">About</h5>
            <ul>
              <li>
                <router-link
                  :to="{path :'/pages/about',
                  query: {
                    display_text: 'About Us',
                  }}"
                  id="footerLink1-about-us"
																		data-test="footerLink1"
                >
                  About Us
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{path :'/pages/contact',
                  query: {
                    display_text: 'Contact Us',
                  }}"
                  id="footerLink2-contact-us"
																		data-test="footerLink2"
                >
                  Contact Us
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{path :'/pages/privacy',
                  query: {
                    display_text: 'Privacy Policy',
                  }}"
                  id="footerLink3-privacy-policy"
																		data-test="footerLink3"
                >
                  Privacy Policy
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{path :'/pages/terms',
                  query: {
                    display_text: 'Terms and Conditions',
                  }}"
                  id="footerLink4-terms-condition"
																		data-test="footerLink4"
                >
                  Terms and Conditions
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-6 col-xl-3 wp_paymentSecured">
            <h5 data-test="footerHead2" id="footerHead2">Payments Secured By</h5>
            <p>
              <img
                src="@/assets/img/cards/razorPay.png"
                alt="Razorpay"
																data-test="footerImg1"
																id="footerImg1"
              >
            </p>
            <ul>
              <li>
                <img
                  src="@/assets/img/cards/1.png"
                  alt="Brand Logos"
																		data-test="footerImg2"
																		id="footerImg2"
                >
              </li>
              <li>
                <img
                  src="@/assets/img/cards/2.png"
                  alt="Brand Logos"
																		data-test="footerImg3"
																		id="footerImg3"
                >
              </li>
              <li>
                <img
                  src="@/assets/img/cards/3.png"
                  alt="Brand Logos"
																		data-test="footerImg4"
																		id="footerImg4"
                >
              </li>
              <li>
                <img
                  src="@/assets/img/cards/25.png"
                  alt="Brand Logos"
																		data-test="footerImg5"
																		id="footerImg5"
                >
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <h5 data-test="footerHead2" id="footerHead2-contact-address">Contact Address</h5>
            <ul>
              <li data-test="footerHead3" id="footerHead3">
															The Neo Bank,
                <br data-test="footerHead4" id="footerHead4">Attn: Customer Service Ctr.,
                <br data-test="footerHead5" id="footerHead5">409 Silverside Road, Suite 105,
                <!--<br>-->
                <br data-test="footerHead6" id="footerHead6">Wilmington, DE 19809
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-6 col-xl-3">
            <h5 data-test="footerHead7" id="footerHead7">News Letter</h5>
            <div class="wp_newsLeterFormContainer">
              <p data-test="footerHead8" id="footerHead8">
                Know about the upcoming Special Events and New Products via Email Newsletter.
              </p>
              <!--<form action>-->
              <!--<input type="text" placeholder="Email address" name="mail" required>-->
              <!--<input type="submit" value="Subscribe">-->
              <!--</form>-->
              <news-letter-form>
              </news-letter-form>
            </div>
            <!-- <div class="wp_foterSocialIconsContainer">
              <ul>
                <li>
                  <span data-test="footerSpan1">
                    <i class="fab fa-facebook-f"></i>
                  </span>
                </li>
                <li>
                  <span data-test="footerSpan2">
                    <i class="fab fa-twitter"></i>
                  </span>
                </li>
                <li>
                  <span data-test="footerSpan3">
                    <i class="fab fa-linkedin-in"></i>
                  </span>
                </li>
                <li>
                  <span data-test="footerSpan4">
                    <i class="fab fa-instagram"></i>
                  </span>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="wp_copyrightAreaContainer">
      <div class="container wp_maxWidth1800">
        <div class="row m-0 ">
          <div class="col-12  col-lg-8 wp_footerIconsAlignment">
            <ul>
              <li>
                <!--to="/vendorLogin"-->
                <router-link
                  to="/tenant-registration"
                  id="footerLink5-seller-login"
																		data-test="footerLink5"
                >
                  <span>
                    <svg height="512pt" viewBox="-41 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m215 230c63.410156 0 115-51.589844 115-115s-51.589844-115-115-115-115 51.589844-115 115 51.589844 115 115 115zm0 0"/><path d="m269.546875 230h-9.546875v73.515625l19.707031 98.542969c1.074219 5.371094-.863281 10.902344-5.058593 14.425781l-50 42c-2.789063 2.34375-6.21875 3.515625-9.648438 3.515625s-6.859375-1.171875-9.648438-3.515625l-50-42c-4.195312-3.523437-6.132812-9.054687-5.0625-14.425781l19.710938-98.542969v-73.515625h-9.546875c-88.472656 0-160.453125 78.503906-160.453125 175v92c0 8.285156 6.714844 15 15 15h400c8.285156 0 15-6.714844 15-15v-92c0-96.496094-71.980469-175-160.453125-175zm0 0"/><path d="m181.449219 399.230469 33.550781 28.179687 33.550781-28.179687-15.847656-79.230469h-35.40625zm0 0"/><path d="m200 260h30v30h-30zm0 0"/></svg>
                  </span>
                  Be a Tenant
                </router-link>
              </li>
													<li>
                <!--to="/vendorLogin"-->
                <router-link
                  to="/vendorLogin"
                  id="seller-login"
																		data-test="footerLink5"
                >
                  <span>
                    <svg id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m171 362h70v150h-70z"/><path d="m449.243 289.179c-.415.005-.829.008-1.243.008-24.701 0-47.206-9.576-64-25.212-16.794 15.636-39.299 25.212-64 25.212s-47.206-9.576-64-25.212c-16.794 15.636-39.299 25.212-64 25.212s-47.206-9.576-64-25.212c-16.794 15.636-39.299 25.212-64 25.212-.416 0-.823-.003-1.239-.008-7.433-.096-14.723-1.068-21.761-2.853v190.674c0 19.299 15.701 35 35 35h65v-150h-5c-8.284 0-15-6.716-15-15s6.716-15 15-15h240c8.284 0 15 6.716 15 15s-6.716 15-15 15h-5v150h65c19.299 0 35-15.701 35-35v-190.674c-7.038 1.784-14.326 2.756-21.757 2.853z"/><path d="m271 362h70v150h-70z"/><path d="m146.741 127.34h94.259v-126.933c0-.137.017-.271.021-.407h-66.174c.032 1.216-.065 2.452-.344 3.693z"/><path d="m365.259 127.34-27.762-123.647c-.279-1.241-.376-2.478-.344-3.693h-66.173c.003.137.02.27.02.407v126.933z"/><path d="m63.15 259.181c.286.004.565.005.85.005 19.931 0 37.733-9.115 49.471-23.402l-.396-78.445h-113.075v36.892c0 35.175 27.98 64.494 63.15 64.95z"/><path d="m367.414 0 28.592 127.34h109.277l-51.392-114.777c-3.423-7.643-11.016-12.563-19.39-12.563z"/><path d="m115.994 127.34 28.591-127.34h-67.094c-8.37 0-15.961 4.915-19.385 12.553l-51.467 114.787z"/><path d="m241 236.342v-79.002h-97.924l.402 79.553c11.737 13.642 29.114 22.293 48.522 22.293 19.671.001 37.26-8.881 49-22.844z"/><path d="m368.522 236.894.401-79.553h-97.923v79.001c11.74 13.963 29.329 22.845 49 22.845 19.408 0 36.785-8.651 48.522-22.293z"/><path d="m512 194.233v-36.893h-113.076l-.396 78.447c11.738 14.286 29.539 23.4 49.472 23.4.283 0 .566-.002.85-.005 35.17-.457 63.15-29.776 63.15-64.949z"/></svg>
                  </span>
                  Merchant Registration
                </router-link>
              </li>
              <li>
                <router-link
                  to="/agentSignUp"
                  id="footerLink6-agent-login"
																		data-test="footerLink6"
                >
                  <span>
                   <svg height="512pt" viewBox="-62 0 512 512.001" width="512pt" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><path d="m342.234375 0h-81.003906c-24.804688 0-45 20.195312-45 45v26.992188h-23c-8.285157 0-15 6.71875-15 15 0 8.285156 6.714843 15 15 15h23.324219c3.816406 43.886718 40.664062 78.003906 85.175781 78.003906 47.21875 0 85.503906-38.285156 85.503906-85.503906 0-16.480469 0-32.996094 0-49.492188 0-24.804688-20.195313-45-45-45zm0 0"/><path d="m266.777344 217.53125c-10.945313 4.941406-20.667969 12.101562-28.574219 20.894531l-80.640625 82.570313h-112.5625c-24.78125 0-45 20.222656-45 45.003906 0 24.777344 20.222656 45 45 45h126.003906c13.824219 0 27.527344-3.472656 37.820313-13.839844l13.410156-13.5v113.332032c0 7.265624 5.160156 13.625 12.015625 15.007812l138.003906-.007812c8.273438-.007813 14.980469-6.722657 14.980469-15v-201.496094c0-61.597656-63.984375-103.453125-120.457031-77.964844zm0 0"/><path d="m41.226562 290.996094h108.003907c8.285156 0 15-6.714844 15-15v-107c0-8.285156-6.714844-15-15-15h-39v25.765625c0 8.285156-6.71875 15-15 15-8.285157 0-15-6.714844-15-15v-25.765625h-39.003907c-8.28125 0-15 6.714844-15 15v107c0 8.285156 6.71875 15 15 15zm0 0"/></g></svg>
                  </span>
                  Be an Agent
                </router-link>
              </li>
              <li>
                <span data-test="footerSpan5" id="footerSpan5">
                  <span>
                    <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m204.675781 214.570312h16.050781l-8.027343-28.320312zm0 0"/><path d="m352 110.355469h-192c-13.878906 0-25.167969 11.289062-25.167969 25.167969v133.519531c0 13.875 11.289063 25.167969 25.167969 25.167969h192c13.878906 0 25.164062-11.292969 25.164062-25.167969v-133.519531c0-13.878907-11.285156-25.167969-25.164062-25.167969zm-107.648438 155.152343c-8.515624 0-10.820312-5.265624-11.417968-7.527343l-5.148438-18.019531h-30.007812l-5.171875 18.109374c-.570313 2.171876-2.875 7.4375-11.398438 7.4375-7.222656 0-17.671875-4.691406-17.671875-13.175781 0-.875.210938-1.71875.453125-2.695312.019531-.078125 31.074219-101.296875 31.074219-101.296875 1.863281-6.214844 8.789062-10.246094 17.636719-10.246094 9.082031 0 15.90625 3.9375 17.808593 10.273438l31.144532 101.574218c.167968.632813.378906 1.421875.378906 2.390625-.003906 8.484375-10.457031 13.175781-17.679688 13.175781zm104.117188-41.292968c0 26.242187-15.40625 41.292968-42.261719 41.292968h-28.4375c-7.660156 0-13.660156-4.796874-13.660156-10.925781v-104.601562c0-6.125 6-10.925781 13.660156-10.925781h28.4375c26.855469 0 42.261719 15.050781 42.261719 41.292968zm0 0"/><path d="m306.207031 166.371094h-12.210937v71.820312h12.210937c8.558594 0 12.371094-4.308594 12.371094-13.976562v-43.867188c0-9.664062-3.8125-13.976562-12.371094-13.976562zm0 0"/><path d="m456.832031 0h-401.667969c-30.417968 0-55.164062 24.746094-55.164062 55.167969v293.265625c0 30.417968 24.746094 55.167968 55.164062 55.167968h161.734376v30.199219h-81.398438c-21.5625 0-39.101562 17.539063-39.101562 39.101563 0 21.558594 17.539062 39.097656 39.101562 39.097656h241c21.558594 0 39.101562-17.539062 39.101562-39.101562 0-21.558594-17.542968-39.097657-39.101562-39.097657h-81.398438v-30.199219h161.730469c30.421875 0 55.167969-24.75 55.167969-55.167968v-293.265625c0-30.421875-24.746094-55.167969-55.167969-55.167969zm-49.667969 269.042969c0 30.417969-24.746093 55.167969-55.164062 55.167969h-192c-30.421875 0-55.167969-24.75-55.167969-55.167969v-133.519531c0-30.417969 24.746094-55.167969 55.167969-55.167969h192c30.417969 0 55.164062 24.75 55.164062 55.167969zm0 0"/></svg>

                  </span>
                  Advertise
                </span>
              </li>
              <li>
                <router-link to="/user/giftCards"
																													data-test="footerLink7" id="footerLink7">
                  <span>
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M267.274 226c-6.749 19.993-24.67 32.139-44.383 32.139-3.157 0-6.253-.742-9.355-1.377l23.945 35.918c4.6 6.899 2.739 16.201-4.16 20.801-7.009 4.645-16.276 2.637-20.801-4.16L180 260.541V436h287c24.814 0 45-20.186 45-45V226H267.274zM437 376H315c-8.291 0-15-6.709-15-15s6.709-15 15-15h122c8.291 0 15 6.709 15 15s-6.709 15-15 15zm0-60H315c-8.291 0-15-6.709-15-15s6.709-15 15-15h122c8.291 0 15 6.709 15 15s-6.709 15-15 15zM213.413 196.747L192.041 211l21.372 14.253c11.378 7.584 26.587-.564 26.587-14.238 0-13.735-15.253-21.824-26.587-14.268zM45 76C20.186 76 0 96.186 0 121v75h62.726c10.146-30.053 45.046-41.168 70.501-24.214L150 182.97V76H45zM467 76H180v106.97l16.772-11.184c25.186-16.826 60.293-6.061 70.508 24.214H512v-75c0-24.814-20.186-45-45-45zM116.587 196.747C105.192 189.15 90 197.348 90 210.985c0 13.678 15.154 21.877 26.587 14.268L137.959 211l-21.372-14.253zM117.48 309.32c-4.6 6.87-13.901 8.701-20.801 4.16-6.899-4.6-8.76-13.901-4.16-20.801l23.945-35.918c-3.102.635-6.198 1.377-9.355 1.377-19.761 0-37.661-12.195-44.39-32.139H0V391c0 24.814 20.186 45 45 45h105V260.541l-32.52 48.779z"/></svg>
                  </span>
                  Gift Cards
                </router-link>
              </li>
              <li>
                <span data-test="footerSpan6" id="footerSpan6">

                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M257 0C116.39 0 0 114.39 0 255s116.39 257 257 257 255-116.39 255-257S397.61 0 257 0zm0 437c-16.54 0-30-13.46-30-30s13.46-30 30-30c16.53 0 30 13.46 30 30s-13.47 30-30 30zm53.17-184.39C295.21 263.6 287 292.63 287 307.12V315c0 16.54-13.47 30-30 30-16.54 0-30-13.46-30-30v-7.88c0-33.65 17.38-80.68 47.71-102.89C298.01 187.12 285.91 150 257 150c-16.54 0-30 13.46-30 30s-13.47 30-30 30c-16.54 0-30-13.46-30-30 0-49.63 40.37-90 90-90s90 40.37 90 90c0 28.57-13.77 55.71-36.83 72.61z"/></svg>
                  </span>
                  Help Center
                </span>
              </li>
            </ul>
          </div>

          <div class="col-12 col-lg-4 text-center">
            <div class="iconnect">
              <p>
                Powered By
              </p>
              <a href="https://iconnect101.com/">
                <img
                  src="https://tstecommerce.s3.amazonaws.com/ec-bank-demo/PROFILE_PICTURE2084293909-bb16cfff-1c9e-41c3-9f11-fa5d06988be9.png"
                  alt="iconnectLogo"
                  srcset=""
                >
              </a>
            </div>

          </div>
        </div>
        <div class="row m-0">
          <div class="col-12">
            <p
              id="copyright"
              class="text-center"
            >&copy; Copyright {{new Date().getFullYear()}} - All rights reserved.</p>
          </div>
        </div>
      </div>
      <!-- <div class="footer-top p-y-2 d-none">
      <div class="container-fluid"></div>
      </div>-->
      <!--<div class="footer-middle">-->
      <!--<div class="footer-body mx-auto">-->
      <!--<div class="row">-->
      <!--&lt;!&ndash; <div class="col-md-3 col-sm-6">-->
      <!--<div class="footer-pad">-->
      <!--<h4>Address</h4>-->
      <!--<address>-->
      <!--<ul class="list-unstyled">-->
      <!--<li>-->
      <!--City Hall<br>-->
      <!--212  Street<br>-->
      <!--Lawoma<br>-->
      <!--735<br>-->
      <!--</li>-->
      <!--<li>-->
      <!--Phone: 0-->
      <!--</li>-->
      <!--</ul>-->
      <!--</address>-->
      <!--</div>-->
      <!--</div> &ndash;&gt;-->
      <!--<div class="col-md-3 col-sm-6">-->
      <!--&lt;!&ndash;Column1&ndash;&gt;-->
      <!--<div class="footer-pad">-->
      <!--<h5 id="popular-footer">Popular Services</h5>-->
      <!--<ul class="list-unstyled">-->
      <!--<li><a href="#"></a></li>-->
      <!--<li><a href="#" id="payment-footer">Payment Center</a></li>-->
      <!--<li><a href="#" id="contact-footer">Contact Directory</a></li>-->
      <!--<li><a href="#" id="forms-footer">Forms</a></li>-->
      <!--<li><a href="#" id="news-footer">News and Updates</a></li>-->
      <!--<li><a href="#" id="paymentfaq-footer">FAQs</a></li>-->
      <!--</ul>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="col-md-3 col-sm-6">-->
      <!--&lt;!&ndash;Column1&ndash;&gt;-->
      <!--<div class="footer-pad">-->
      <!--<h5 id="website-footer">Website Information</h5>-->
      <!--<ul class="list-unstyled">-->
      <!--<li><a href="#" id="webtutorial-footer">Website Tutorial</a></li>-->
      <!--<li><a href="#" id="accessibility-footer">Accessibility</a></li>-->
      <!--<li><a href="#" id="disclaimer-footer">Disclaimer</a></li>-->
      <!--<li><a href="#" id="privacy-footer">Privacy Policy</a></li>-->
      <!--<li><a href="#" id="websfaq-footer">FAQs</a></li>-->
      <!--<li><a href="#" id="webmaster-footer">Webmaster</a></li>-->
      <!--</ul>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="col-md-3 col-sm-6">-->
      <!--&lt;!&ndash;Column1&ndash;&gt;-->
      <!--<div class="footer-pad">-->
      <!--<h5 id="follow-footer">Follow us</h5>-->
      <!--<ul class="list-unstyled">-->
      <!--<li><a href="#" id="facebook-footer">Facebook</a></li>-->
      <!--<li><a href="#" id="twitter-footer">Twitter</a></li>-->
      <!--<li><a href="#" id="intsgram-footer">Instagram</a></li>-->
      <!--</ul>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="col-md-3 col-sm-6">-->
      <!--<div class="form-group">-->
      <!--<h5 for="" id="newsletter-footer">Sign up for our Newsletter</h5>-->
      <!--<div class="input-group mb-3">-->
      <!--<input type="email" class="form-control" placeholder="Email"
      aria-label="Recipient's username" aria-describedby="basic-addon2"-->
      <!--id="newsletter-email">-->
      <!--<div class="input-group-append">-->
      <!--<button class="btn btn-outline-secondary" type="button"-->
      <!--id="newsletter-btn"></button>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="row">-->
      <!--<div class="col-md-6 d-none d-md-block">-->
      <!--<img src="@/assets/img/trust-01.png" alt=""-->
      <!--id="footerimg">-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!-- <div class="footer-bottom row">-->
      <!--<div class="col-0 d-none d-md-block col-md-3 order-1 order-md-1"></div>-->
      <!--<div class="col-12 col-md order-3 order-md-2">-->
      <!--<div class="iconnect">-->
      <!--<p>-->
      <!--Powered By-->
      <!--</p>-->
      <!--<img src="@/assets/img/iconnect-logo.png"-->
      <!--alt=""-->
      <!--srcset=""-->
      <!--&gt;-->
      <!--</div>-->
      <!--<div class="container">-->
      <!--Footer Bottom-->
      <!-- <p>
            <router-link to="/pages/privacy"
                         id="privacy-policy"
            >
              Privacy Policy
            </router-link>
            <span>|</span>
            <router-link to="/pages/terms"
                         id="terms-condition"
            >
              Terms and Conditions
            </router-link>
      <span>|</span>-->
      <!--<a href="#"-->
      <!--id="site-map">-->
      <!--Sitemap-->
      <!--</a>-->
      <!--<span>|</span>-->
      <!-- <router-link to="/pages/about"
                         id="about-us"
            >
              About Us
            </router-link>

            <span>|</span>
            <router-link to="/vendorLogin"
                         id="seller-login"
            >
              Seller Login
      </router-link>-->
      <!--<span>|</span>-->
      <!--<router-link to="/pages/TenantLogin"-->
      <!--id="tenant-login"-->
      <!--&gt;-->
      <!--Tenant Login-->
      <!--</router-link>-->
      <!-- </p>
          <p id="copyright">
            &copy; Copyright {{new Date().getFullYear()}} - All rights reserved.
          </p>
        </div>
      </div>
      <div class="col-12 col-md-3 col-sm-6 order-2 order-md-3">
        <div class="form-group">
          <h5 for="" id="newsletter-footer">
            Sign up for our Newsletter
          </h5>
          <news-letter-form>
          </news-letter-form>
        </div>
      </div>-->
    </div>
  </footer>
  <!-- footer -->
</template>

<script>
import NewsLetterForm from '@/components/shared/forms/newsLetterForm'

export default {
	components: {
		NewsLetterForm
	}
}
</script>
